// extracted by mini-css-extract-plugin
export default {"imageUploadForm":"imageUploadForm_imageUploadForm__ZTjjs","fileDropWrapper":"imageUploadForm_fileDropWrapper__g7VyE","inputWrapper":"imageUploadForm_inputWrapper__kYJF+"};